import { I18n } from "aws-amplify/utils";

/**
 * Amplify's sign-in form renders SDK and Cognito error strings verbatim, and
 * several of them read as internal diagnostics rather than user-facing copy.
 */
const AUTHENTICATOR_MESSAGE_OVERRIDES: Record<string, string> = {
  "username is required to signIn": "Username is required to sign in",
  "password is required to signIn": "Password is required to sign in",
  "username is required to resetPassword":
    "Username is required to reset your password",
  "Username/client id combination not found.": "Username not found.",
};

/**
 * The UI ships no translations, so the dictionary is pinned to one language.
 *
 * Without this, `I18n.get` resolves against `window.navigator.language` and the
 * overrides below would silently stop applying for anyone whose browser is not
 * set to English.
 */
const AUTHENTICATOR_LANGUAGE = "en";

export function applyAuthenticatorMessageOverrides(): void {
  I18n.setLanguage(AUTHENTICATOR_LANGUAGE);
  I18n.putVocabulariesForLanguage(
    AUTHENTICATOR_LANGUAGE,
    AUTHENTICATOR_MESSAGE_OVERRIDES,
  );
}
